import { defineField, defineType } from 'sanity'

/**
 * Validate URL paths for Next.js redirects
 * https://nextjs.org/docs/app/api-reference/config/next-config-js/redirects
 *
 * - Must start with '/'
 * - valid chars: a-z, A-Z, 0-9, -, _, :
 * - optional trailing *
 * - optional query params (?key=value)
 * - optional fragment (#section)
 */

const PATH_REGEX = /^\/([a-zA-Z0-9\-_:]+\/?)*(\*?)(\?.*)?(#.*)?$/

export default defineType({
  name: 'redirect',
  title: 'Redirect',
  type: 'document',
  orderings: [
    {
      title: 'Source A-Z',
      name: 'sourceAsc',
      by: [{field: 'source', direction: 'asc'}],
    },
  ],
  fields: [
    defineField({
      name: 'source',
      title: 'Source path',
      type: 'string',
      description: 'The path to redirect from (e.g. /old-path)',
      validation: (Rule) =>
        Rule.required().regex(
          PATH_REGEX,
          "The path must start with '/' and be a valid path, with support for '*' wildcards, query parameters, and fragments."
        ),
    }),
    defineField({
      name: 'destination',
      title: 'Destination path',
      type: 'string',
      description: 'The path to be redirected to (e.g. /new-path)',
      validation: (Rule) =>
        Rule.required().regex(
          PATH_REGEX,
          "The path must start with '/' and be a valid path, with support for '*' wildcards, query parameters, and fragments."
        ),
    }),
    defineField({
      name: 'permanent',
      title: 'Permanent redirect',
      type: 'boolean',
      description:
        'Whether this is a permanent redirect (301) or temporary (302)',
      initialValue: true,
    }),
  ],
  preview: {
    select: {
      title: 'source',
      subtitle: 'destination',
      permanent: 'permanent',
    },
    prepare(selection) {
      const { title, subtitle } = selection
      return {
        title,
        subtitle,
      }
    },
  },
})